import { render, staticRenderFns } from "./MyBoxes.vue?vue&type=template&id=00d08516"
import script from "./MyBoxes.vue?vue&type=script&lang=js"
export * from "./MyBoxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports